<template>
    <div id="onboardingStaff" class="onboarding step-container">
        <preloader :display="loading"> </preloader>

        <div class="aright">
            <LangSelector :modelValue="locale" />
        </div>

        <!-- CONTENT -->
        <el-form
            ref="onboardingForm"
            class="step-slide-container"
            labelPosition="top"
            :model="staff"
            :inlineMessage="true"
            labelWidth="120px"
        >
            <!-- STEP 1 -->
            <div class="step active" step-id="1">
                <div class="step-division division-2 br-1-color26">
                    <img src="/ressources/public/img/onboarding/Sellsy_produit_onboarding1.png" />
                </div>
                <div class="step-division division-2">
                    <h2 class="mb-0 lh-reset">{{ $l10n.__('Créez votre profil') }}</h2>
                    <p class="mt-0 mb-7 semibold gray-60">
                        {{ $l10n.__('Afin de pouvoir rejoindre votre équipe') }}
                    </p>

                    <el-form-item
                        :label="$t.__('common.labels.first_name')"
                        prop="forename"
                        :error="errors.get('forename')"
                    >
                        <TextInput
                            v-model="staff.forename"
                            mode="edit"
                            :placeholder="$t.__('common.labels.first_name')"
                        />
                    </el-form-item>
                    <el-form-item
                        :label="$t.__('common.labels.name')"
                        prop="name"
                        :error="errors.get('name')"
                    >
                        <TextInput
                            v-model="staff.name"
                            mode="edit"
                            :placeholder="$t.__('common.labels.name')"
                        />
                    </el-form-item>
                    <div class="acenter">
                        <CompassButton
                            :label="$t.__('common.actions.continue')"
                            type="primary"
                            @click.prevent="validateStep"
                        />
                    </div>
                </div>
            </div>
        </el-form>
    </div>
</template>

<script>
import FormMixins from '../../mixins/FormMixins';
import Preloader from 'vcomponents/utilities/Preloader.vue';
import TextInput from 'vcomponents/inputs/TextInput.vue';
import LangSelector from 'vcomponents/utilities/LangSelector.vue';
import { createNamespacedHelpers } from 'vuex';
const { mapState } = createNamespacedHelpers('user');

import PopinMixins from 'mixins/PopinMixins';

export default {
    mixins: [FormMixins, PopinMixins],
    props: {
        name: {
            type: String,
        },
        forename: {
            type: String,
        },
        lang: {
            type: String,
        },
    },

    data() {
        return {
            loading: false,
            staff: {
                forename: false,
                name: false,
            },
            form: false,
        };
    },

    created() {
        this.staff.forename = this.forename;
        this.staff.name = this.name;
    },

    computed: {
        ...mapState({
            locale: 'locale',
        }),
    },

    methods: {
        validateStep() {
            this.loading = true;

            this.$ajax.post(
                `/onboarding/staff/store`,
                {},
                this.staff,
                (response) => {
                    if (
                        typeof response.form !== 'undefined' &&
                        response.form.status == 'failed' &&
                        response.form.fields.length > 0
                    ) {
                        response.form.fields.map((field) => {
                            this.errors.setOneError(field.fieldId, field.msg);
                        });
                        this.loading = false;
                    } else {
                        this.callNextPopin('onboarding-staff').then(() => Utils.relocate('/'));
                    }
                },
                (error) => {
                    Push.error(this.$l10n.__('Une erreur est survenue'));
                    this.loading = false;
                },
            );
        },
    },

    components: {
        Preloader,
        TextInput,
        LangSelector,
    },
};
</script>
